<template>
  <div style="border: solid 1px #999" class="pa-2">
    <div class="v-label theme--light pb-2">{{ ctrlTitle }}</div>
    <v-checkbox
      v-for="f in listItems"
      :key="f.name"
      :hide-details="true"
      :label="f.name"
      :value="f.name"
      v-model="columns"
    ></v-checkbox>
    <div v-if="!listItems || listItems.length == 0">No column.</div>
  </div>
</template>

<script>
import server from "../../../services/server.js";

export default {
  name: "ServerFieldMultiSelect",

  props: ["value", "title", "table"],

  data() {
    return {
      listItems: null,
      columns: [],
    };
  },

  computed: {
    ctrlTitle() {
      return this.title ? this.title : "Data Columns";
    },
  },

  mounted() {
    this.loadFields();

    if (this.value) this.columns = this.value;
  },

  watch: {
    table() {
      this.loadFields();
    },
    value(v) {
      if (v) this.columns = v;
      else this.columns = [];
    },
    columns(v) {
      this.$emit("input", v);
    },
  },

  methods: {
    loadFields() {
      if (this.table) {
        server.get("datafields/bytable/" + this.table).then((response) => {
          this.listItems = response;
        });
      } else if (this.fields) {
        this.listItems = [];

        for (let i = 0; i < this.fields.length; i++) {
          const f = this.fields[i];
          this.listItems.push({ name: f });
        }
      }
    },
  },
};
</script>
